import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class MediaApiService extends ApiService {
  static async get(params: object): Promise<object> {
    return this.axios.get('media/all', {
      params
    })
      .then((response: AxiosResponse) => response.data)
  }

  static async update(mediaId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.patch('media', {
      uuid: mediaId,
      ...data
    })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async delete(mediaId: string): Promise<AxiosResponse> {
    return this.axios.delete(`media/${mediaId}`)
  }

  static async togglePlayerVisibility(mediaId: string): Promise<IServiceResponse<object>> {
    return this.axios.get(`media/${mediaId}/toggle-player-visibility`)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async copy(mediaId: string): Promise<IServiceResponse<object>> {
    return this.axios.post('media/copy', {
      media_id: mediaId
    })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
